export const certificateData = [
  { label: '다음에 설정', value: 0 },
  { label: '사업자 등록증', value: 1 },
  { label: '고유번호 등록증', value: 2 }
];

export const certificateTwoData = [
  { label: '사업자 등록증', value: 1 },
  { label: '고유번호 등록증', value: 2 }
];

export const PRE_SIGNUP_STATUS = {
  NEW: 'new user',
  PRE_SIGNUP: 'pre_signup user',
  USER: 'user',
  BIZ_USER: 'biz user'
} as const;

export const INPUT_WIDTH = {
  X_SMALL: 100,
  SMALL: 230,
  MIDDLE: 312,
  LARGE: 480
} as const;

export const INITIAL_JOIN_INFO = {
  companyname: '',
  address: '',
  number: '',
  usridx: 0,
  usrid: '',
  usrname: '',
  usrbirth: '',
  usrgender: 1,
  usrphoneno: '',
  usrphoneregioncodeidx: 0,
  usrphoneregioncode: '',
  countryphoneno: '',
  presignupidx: 0,
  bizcerttype: 1,
  contracturl: '',
  contractname: '',
  countrycode: 'KR',
  zipcode: '',
  isContractAgreed: false,
  usrpw: '',
  passwordCheck: ''
};

export const JOIN_STEP = [1, 2, 3];

export const EMAIL_LIST = [
  {
    key: 0,
    value: '직접입력'
  },
  {
    key: 1,
    value: 'naver.com'
  },
  {
    key: 2,
    value: 'gmail.com'
  },
  {
    key: 3,
    value: 'daum.net'
  },
  {
    key: 4,
    value: 'kakao.com'
  },
  {
    key: 5,
    value: 'hanmail.net'
  },
  {
    key: 6,
    value: 'nate.com'
  }
];

export const SELECT_GENDER = [
  {
    label: '남',
    value: 1
  },
  {
    label: '여',
    value: 2
  }
];
